import { render, staticRenderFns } from "./ClassSelect.vue?vue&type=template&id=5ac3918c&scoped=true"
import script from "./ClassSelect.vue?vue&type=script&lang=js"
export * from "./ClassSelect.vue?vue&type=script&lang=js"
import style0 from "./ClassSelect.vue?vue&type=style&index=0&id=5ac3918c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3918c",
  null
  
)

export default component.exports